module.exports = __webpack_public_path__ + "static/media/dashboard.8ed99851.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard.png
// module id = 658
// module chunks = 0